// Billing portal link data model for the SaaS billing prototype.
// See plans/saas-billing/01-stripe-billing-foundation.md for canonical types.

export interface BillingPortalLink {
  url: string;                         // Pre-signed Stripe Customer Portal URL
  expiresAt: string;
  returnUrl: string;                   // Where Portal sends user back to
}
